import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatAutocompleteSelectedEvent, MatDialogRef, MAT_DIALOG_DATA, MatSelectChange } from '@angular/material';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { debounceTime } from 'rxjs/operators/debounceTime';
import { distinctUntilChanged } from 'rxjs/operators/distinctUntilChanged';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { map } from 'rxjs/operators/map';
import { Observable } from 'rxjs/Observable';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { Subject } from 'rxjs/Subject';

import { CollegeCourseInfo, CollegeDepartmentInfo } from '../../application/application.service';

@Component({
    selector: 'dialog-coursechoice-component',
    styleUrls: ['coursechoice.dialogcomponent.css'],
    templateUrl: 'coursechoice.dialogcomponent.html',
})
export class CourseChoiceDialogComponent implements OnInit, OnDestroy {
    @ViewChild('filter') filter: ElementRef;

    private _subRelease: Subject<void> = new Subject<void>();

    title: string;
    message: string;
    oktext: string;
    canceltext: string;

    CanMakeAdoptionRequest: boolean;
    CourseChoice: CollegeCourseInfo;
    Courses: CollegeCourseInfo[];
    CourseSearch: string;
    DepartmentChoice: number;
    Departments: CollegeDepartmentInfo[];
    FilteredCourses: CollegeCourseInfo[];

    constructor(
        public dialogRef: MatDialogRef<CourseChoiceDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: BaseCourseChoiceDialogOptions
    ) {
        this.title = data.TitleText || 'Please wait...';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || '';
        this.canceltext = data.CancelText || '';

        this.CanMakeAdoptionRequest = data.CanMakeAdoptionRequest != null ? data.CanMakeAdoptionRequest : false;
        this.Courses = data.Courses || [];
        this.Departments = data.Departments || [];
        this.FilteredCourses = <CollegeCourseInfo[]>JSON.parse(JSON.stringify(data.Courses));
    }

    CancelHandler() {
        this.dialogRef.close(null);
    }

    ngOnDestroy() {
        this._subRelease.next();
        this._subRelease.complete();
    }

    ngOnInit() {
        fromEvent(this.filter.nativeElement, 'keyup')
            .pipe(
                takeUntil(this._subRelease),
                debounceTime(150),
                distinctUntilChanged()
            )
            .subscribe(() => {
                const newvalue = this.filter.nativeElement.value.toLowerCase();

                const fcourses = this.Courses.filter(item => {
                    let keep = false;

                    if (item.FullCode.toLowerCase().indexOf(newvalue) >= 0) {
                        keep = true;
                    }
                    if (!keep && item.Corequisites.toLowerCase().indexOf(newvalue) >= 0) {
                        keep = true;
                    }
                    if (!keep && item.Description.toLowerCase().indexOf(newvalue) >= 0) {
                        keep = true;
                    }
                    if (!keep && item.Name.toLowerCase().indexOf(newvalue) >= 0) {
                        keep = true;
                    }
                    if (!keep && item.Prerequisites.toLowerCase().indexOf(newvalue) >= 0) {
                        keep = true;
                    }

                    return keep;
                });

                this.FilteredCourses = fcourses;
            });
    }

    OKHandler(priority: any) {
        // The user has chosen to select the course. Return the course selected.
        this.CourseChoice.PriorityRequest = priority === 1;

        this.dialogRef.close(<BaseCourseChoiceResult>{
            RequestAdoption: false,
            CourseChoice: this.CourseChoice,
        });
    }

    // #region Autocomplete Selected Method

    AutocompleteSelected(course: MatAutocompleteSelectedEvent) {
        const self = this;

        if (!course || !course.option) {
            return;
        }

        // Scan through and if we have a department, select it, and then select the course as well.
        const newoption = <CollegeCourseInfo>course.option.value;

        if (newoption.Department != null) {
            self.DepartmentChoice = newoption.Department;

            if (self.Departments && self.Departments[self.DepartmentChoice]) {
                const newcourse = self.Departments[self.DepartmentChoice].Courses.find(item => {
                    return item.DualEnrollCollegeCourseID === newoption.DualEnrollCollegeCourseID;
                });
                if (newcourse) {
                    self.CourseChoice = newcourse;
                }
            }
        }
    }

    // #endregion

    // #region Display Function Method

    DisplayFn(course: CollegeCourseInfo) {
        return course ? `${course.Prefix} ${course.Code} - ${course.Name}` : course;
    }

    // #endregion

    // #region Go To Adoption Request Method

    GoToAdoptionRequest() {
        // Exit out, but use a packet that lets the client know the user wants to go to the adoption form.
        this.dialogRef.close(<BaseCourseChoiceResult>{
            RequestAdoption: true,
            CourseChoice: this.CourseChoice,
        });
    }

    // #endregion

    // #region Update Filter Method

    UpdateFilter(event: MatSelectChange) {
        if (!event || !event.value) {
            return;
        }

        const course = <CollegeCourseInfo>event.value;
        this.filter.nativeElement.value = `${course.Prefix} ${course.Code} - ${course.Name}`;
    }

    // #endregion
}

// #region Custom Classes

export class BaseCourseChoiceDialogOptions {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    CanMakeAdoptionRequest?: boolean;
    Courses?: CollegeCourseInfo[];
    Departments?: CollegeDepartmentInfo[];
}

export class BaseCourseChoiceResult {
    RequestAdoption?: boolean;
    CourseChoice?: CollegeCourseInfo;
}

// #endregion



// WEBPACK FOOTER //
// ./src/services/dialogs/coursechoice/coursechoice.dialogcomponent.ts